import { Injectable, Inject, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, forkJoin, of, Observable } from 'rxjs';
import { exhaustMap, map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { TableService, TableResponseModel, ITableState , BaseModel, PaginatorState, SortState, GroupingState } from '../../_metronic/shared/crud-table';
import { Policy } from '../_models/policy.model';
import { Ramo, SubRamo, Mes, Anyo, Endoso } from '../_models/general.model';
import { baseFilter } from '../../_fake/fake-helpers/http-extenstions';
import { catchError, finalize, tap } from 'rxjs/operators';
import { first } from 'rxjs/operators';
import { AuthService } from '../../modules/auth/_services/auth.service';

const DEFAULT_STATE: ITableState = {
  filter: {},
  paginator: new PaginatorState(),
  sorting: new SortState(),
  searchTerm: '',
  grouping: new GroupingState(),
  entityId: undefined,
  paramsGet: "",
  paramsPost: {}
};

@Injectable({
  providedIn: 'root'
})
export class InsuranceService extends TableService<Policy> implements OnDestroy {
  
  apiUrls = {
    getRamo : `${environment.url}/${environment.apiUrl}/Generico/get_ramos?`,
    getSubRamo : `${environment.url}/${environment.apiUrl}/Generico/get_sub_ramos?`,
    getMes : `${environment.url}/${environment.apiUrl}/Generico/get_meses?`,
    getAnyo : `${environment.url}/${environment.apiUrl}/Generico/get_anos?`,
    getPolicy : `${environment.url}/${environment.apiUrl}/Producer/get_Listados_De_Polizas?`,
    getEndosos : `${environment.url}/${environment.apiUrl}/Generico/get_endosos?`,
    postEndosos : `${environment.url}/${environment.apiUrl}/Generico/post_solicitud_endosos?`,
    
  }

  API_URL = `${environment.url}/${environment.apiUrl}/Producer/get_Listados_De_Polizas`;
  constructor(@Inject(HttpClient) http, private auth: AuthService) {
    super(http);
  }

   // READ
   find(tableState: ITableState): Observable<TableResponseModel<Policy>> {
    return this.http.get<Policy[]>(this.apiUrls.getPolicy + tableState.paramsGet, {headers: this.auth.httpHeaders}).pipe(
      map((response: Policy[]) => {
        const filteredResult = baseFilter(response, tableState);
        const result: TableResponseModel<Policy> = {
          items: response, // filteredResult.items,
          total: filteredResult.total
        };
        return result;
      })
    );
  }

  

  // READ
  async getRamos(paramsGet: string = "") {
    var response = await this.http.get<Ramo>(this.apiUrls.getRamo + paramsGet, {headers: this.auth.httpHeaders}).toPromise();
    if(typeof response != 'undefined') {
      return response;
    }
  }

  // READ
  async getSubRamos(paramsGet: string = "") {
    var response = await this.http.get<SubRamo>(this.apiUrls.getSubRamo + paramsGet, {headers: this.auth.httpHeaders}).toPromise();
    if(typeof response != 'undefined') {
      return response;
    }
  }

  // READ
  async getMeses(paramsGet: string = "") {
    var response = await this.http.get<SubRamo>(this.apiUrls.getMes + paramsGet, {headers: this.auth.httpHeaders}).toPromise();
    if(typeof response != 'undefined') {
      return response;
    }
  }

  // READ
  async getAnyos(paramsGet: string = "") {
    var response = await this.http.get<SubRamo>(this.apiUrls.getAnyo + paramsGet, {headers: this.auth.httpHeaders}).toPromise();
    if(typeof response != 'undefined') {
      return response;
    }
  }

  // READ
  async getEndosos(paramsGet: string = "") {
    var response = await this.http.get<Endoso>(this.apiUrls.getEndosos + paramsGet, {headers: this.auth.httpHeaders}).toPromise();
    if(typeof response != 'undefined') {
      return response;
    }
    else {
      return false;
    }
  }


  async postEndoso(endoso: any, doc: any) {
    var data = new FormData();
    data.append("data", JSON.stringify([endoso]));
    debugger;
    data.append("file1", doc.files[0]);
    return await this.http.post<Endoso>(this.apiUrls.postEndosos, data, {headers: this.auth.httpHeaders}).toPromise();
  } 

  extracData(id, policies) {
    var item;

    //FEXME
    policies.pipe().subscribe(items => {
      return items.filter(c => {
        if(c.IdPoliza == id) {
          return (item = c);
        }
      });
    });
        
    return item;
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sb => sb.unsubscribe());
  }
}
